import syncRouterWithHistory from '../syncRouterWithHistory';

function initTPAViewModeStandalone() {
  syncRouterWithHistory();
}

export default initTPAViewModeStandalone;
